<template>
  <div class="content">
    <div class="goods" v-if="itemDetail.link" @click="buy">
      <div class="goods-img">
        <img :src="itemDetail.coverImage.url" alt="" />
      </div>
      <div class="goods-info">
        <p class="goods-title">{{ itemDetail.title | replaceStr }}</p>
        <p class="goods-subtitle">{{ itemDetail.subTitle }}</p>
      </div>
      <div class="btn">立即购买</div>
    </div>
    <div v-if="itemDetail.video" class="video">
      <div v-html="itemDetail.video"></div>
    </div>
    <div v-if="itemDetail.tips" class="tips">
      <img src="./instruct_nor.png" alt="" />
      <p>温馨提示：{{ itemDetail.tips }}</p>
    </div>
    <div class="info">
      <div class="info-l">
        <div class="title">{{ itemDetail.title }}</div>
        <div class="sub-title">{{ itemDetail.subTitle }}</div>
      </div>
      <div class="info-r" @click="toService">
        <img src="./service_btn.png" alt="">
      </div>
    </div>
    <div class="section">
      <div class="section-title">适用车型</div>
      <div class="applied" v-html="itemDetail.applied"></div>
    </div>
    <div class="section" style="margin-top: 0.8rem" v-if="itemDetail.steps">
      <div class="section-title">图文教程</div>
      <div class="steps" v-html="itemDetail.steps"></div>
    </div>
    <div class="side-nav">
      <div><img src="./copylink.png" alt="" @click="copylink"></div>
      <div class="line"></div>
      <div><img src="./gohome.png" alt="" @click="gohome"></div>
    </div>
    <div v-if="isShowserviceCode" class="showCode" @click="() => isShowserviceCode = false">
      <img src="https://static0.xiaote.com/frontend/instructionSheetCode.png" alt="" @click.stop>
    </div>
  </div>
</template>
<script>
import Utils from "../../libs/utils";
import { getItemDetail } from "../../http/api";
let is_weixin = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";

export default {
  name: "useSwiper",
  computed: {},
  mounted() {
    this.getItemDetail();
  },
  data() {
    return {
      index: 0,
      id: Utils.getQueryString("oid"),
      itemDetail: {},
      isShowserviceCode: false
    };
  },

  filters: {
    replaceStr(str) {
      str = str.replace(/安装/g, "")
      return str.replace(/教程/g, "");
    },
  },

  methods: {
    getItemDetail() {
      getItemDetail({ variables: { instructionId: this.id } }).then((res) => {
        console.log(res);
        let itemDetail = res.data.instructionSheet.itemDetail;
        itemDetail.applied = itemDetail.applied.replace(/\r\n/g, "<br>");
        itemDetail.applied = itemDetail.applied.replace(/\n/g, "<br>");
        if (!is_weixin && itemDetail.taobaoGotoUrl) {
          itemDetail.link = itemDetail.taobaoGotoUrl;
        } else {
          itemDetail.link = itemDetail.youzanGotoUrl;
        }
        this.itemDetail = itemDetail;
      });
    },
    buy() {
      window.open(this.itemDetail.link);
    },

    showServiceCode() {
      this.isShowserviceCode = true
    },

    toService() {
      window.location.href = `https://h5.youzan.com/v2/im?c=wsc&v=2&kdt_id=93708125#talk!id=93708125&sf=wx_menu`
    },

    gohome() {
      window.location.href = `/g/index.html`
    },

    copylink() {
      var oInput = document.createElement("input")
      oInput.value = `教程 ｜ ${this.itemDetail.title}  ${window.location.origin}/g/directions.html?oid=${this.id}`
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand("Copy")
      oInput.remove()
      // alert('复制成功')
      this.$Alert({message: "复制成功", duration: 2000});
    }
  },
};
</script>
<style scoped >
.content {
  padding: 0 0.36rem;
  box-sizing: border-box;
  background: #faf9fa;
  min-height: 100vh;
  font-size: 0;
  max-width: 750px;
  margin: auto;
}

.goods {
  background: #ffffff;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  padding: 0.16rem;
  padding-right: 0.2rem;
  box-sizing: border-box;
  z-index: 9999;
}

.goods-img {
  width: 1.68rem;
  height: 1.04rem;
  border-radius: 0.06rem;
  overflow: hidden;
}

.goods-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-info {
  margin-left: 0.2rem;
  flex: 1;
  height: 1.04rem;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

.goods-title {
  width: 2.8rem;
  font-weight: 500;
  font-size: 0.24rem;
  line-height: 1.3;
  color: #2f343d;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.goods-subtitle {
  width: 2.8rem;
  font-weight: 400;
  font-size: 0.2rem;
  color: #858d99;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn {
  width: 1.48rem;
  height: 0.5rem;
  background: #2f343d;
  border-radius: 0.1rem;
  font-weight: 500;
  font-size: 0.24rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video {
  width: 6.78rem;
  margin: auto;
  height: 3.8rem;
  overflow: hidden;
  border-radius: 0.12rem;
  padding-top: 0.48rem;
}

.tips {
  display: flex;
  align-items: center;
  margin-top: 0.32rem;
  border: 1px solid rgba(47, 52, 61, 0.05);
  box-sizing: border-box;
  border-radius: 6px;
  padding: 0.2rem 0.28rem;
}

.tips img {
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.2rem;
}

.tips p {
  font-weight: 400;
  font-size: 0.24rem;
  color: #2f343d;
  width: 6rem;
}

.info {
  display: flex;
  align-items: flex-start;
  margin-top: 0.48rem;
  padding-bottom: 0.48rem;
  border-bottom: 0.02rem solid rgba(47, 52, 61, 0.05);
  box-sizing: border-box;
  justify-content: space-between;
}

.info-r img {
  width: 1.88rem;
  height: auto;
  margin-left: .2rem;
}

.title {
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.44rem;
  color: #2f343d;
}

.sub-title {
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.26rem;
  color: #858d99;
  margin-top: 0.16rem;
}

.section {
  margin-top: 0.48rem;
  padding-bottom: 0.48rem;
  border-bottom: 0.02rem solid rgba(47, 52, 61, 0.05);
  box-sizing: border-box;
}

.section-title {
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.44rem;
  color: #2f343d;
}

.applied {
  margin-top: 0.1rem;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 2;
  color: #858d99;
}
</style>
<style>
.steps {
  font-size: 0;
  margin-top: 0.48rem;
}
.steps h1,
.steps h2,
.steps h3,
.steps h4,
.steps h5 {
  margin-top: 0.24rem;
  font-weight: 500;
  font-size: 0.36rem;
  line-height: 0.5rem;
  color: #000000;
}
.steps p {
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #858d99;
  margin-top: 0.08rem;
  margin-bottom: 0.8rem;
}
.steps img {
  border-radius: 0.12rem;
  width: 100%;
  height: auto;
}

.steps .image-wrap {
  position: relative;
}

.steps .image-wrap::after {
  content: attr(index);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 1.2rem;
  height: 0.6rem;
  background: #18191c;
  border-radius: 0.12rem 0px;
  font-weight: 400;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.steps h6 {
  font-weight: 600;
  font-size: 0.32rem;
  line-height: 0.44rem;
  text-transform: capitalize;
  color: #2f343d;
}

.steps ol li {
  list-style-type: decimal;
  list-style-position: inside;
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.4rem;
  margin-top: 0.24rem;
  color: #858d99;
}

.video iframe {
  width: 6.78rem;
  margin: auto;
  height: 3.8rem;
}

.side-nav {
  background: #FFFFFF;
  box-shadow: 0px 35px 28px rgba(0, 0, 0, 0.1);
  border-radius: .65rem;
  width: 1.3rem;
  padding: .32rem .26rem;
  box-sizing: border-box;
  position: fixed;
  right: .36rem;
  bottom: 2rem;
}

.line {
  height: 1px;
  background: #9DA0A5;
  opacity: .1;
  width: .648rem;
  margin: .2rem auto;
}

.side-nav img {
  width: .8rem;
}

.showCode {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.showCode img {
  width: 6.9rem;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?d67c61e8